import { engingeeredSFComplete } from "./EngingeeredSFComplete";

export function getDropDownListOfValidShippingFrequencies(
  validShippingFrequencies: Array<number> | undefined
) {
  const localizedData: { text: string; value: any }[] = [];

  validShippingFrequencies?.forEach((f) => {
    localizedData.push({
      text: engingeeredSFComplete.get(f) ?? "",
      value: f,
    });
  });
  return localizedData;
}
